module.exports = __webpack_public_path__ + "assets/img/world@2x.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/card-logo/world@2x.png
// module id = 145
// module chunks = 0